import { Progress } from '@agro-club/agroclub-shared'
import { refetchFunc, useSingleEntity } from 'modules/domain/common/hooks'
import { endpoints } from 'modules/endpoints'
import { createContext, ReactNode, useContext } from 'react'
import { SamplesForBid } from 'views/pages/Bid/BidDetail/Bid/types'

interface UserSamplesContextType {
  samples?: SamplesForBid[]
  progress: Progress
  refetch: refetchFunc
}

export const UserSamplesContext = createContext<UserSamplesContextType>({
  progress: Progress.IDLE,
  refetch: async () => {
    return undefined
  },
})

export const useUserSamplesContext = () => {
  const context = useContext(UserSamplesContext)

  return context
}

export function UserSamplesProvider({ children, userId }: { children: ReactNode; userId: number }) {
  const [progress, samples, refetch] = useSingleEntity<SamplesForBid[]>(endpoints.samplesForUser(userId.toString()))

  return <UserSamplesContext.Provider value={{ progress, samples, refetch }}>{children}</UserSamplesContext.Provider>
}
